export const COLUMNS = [
  {
    Header: 'Category',
    accessor: 'category',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Logo',
    accessor: 'logo',
  },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
